<template>
   <v-container class='px-0'>
        <v-layout align-center justify-center>
          <v-flex xs12 sm4 md4>
            <v-card class="elevation-12">
              <v-toolbar dark>
                <v-toolbar-title>Login - Display Case Manager</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" name="login" label="E-mail" type="text" v-model="email"></v-text-field>
                  <v-text-field 
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    :type="show2 ? 'text' : 'password'"
                    v-model="password"
                    :append-icon="show2 ? 'visibility_off': 'visibility'"
                    :rules="[rules.required]"
                    @click:append="show2 = !show2"
                     @keyup.enter="login"
                  ></v-text-field>
                </v-form>
                <a @click.prevent="reset">Forgot Password</a>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark @click.native="login">Login</v-btn>
                <v-btn dark @click.native='signup'>Sign Up</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-dialog v-model="openDialog" max-width="500px" >
        <v-card>
          <v-card-title class="error white--text">
            <v-icon class="white--text pr-3">warning</v-icon><span>Login Error</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <p>{{errorMsg}}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="openDialog=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    data: () => ({
      email: '',
      password: '',
      openDialog: false,
      errorMsg: 'Please check your e-mail or password',
      show2: false,
      rules: {
        required: value => !!value || 'Required.'
      }
    }),
    computed: {
      ...mapGetters({currentUser: 'currentUser', er: 'menuStatus'})
    },
    created () {
      this.checkLogin()
    },
    updated () {
      this.checkLogin()
    },
    methods: {
      checkLogin () {
        if (this.currentUser) {
          this.$router.replace(this.$route.query.redirect || '/home')
        }
      },
      login () {
        this.$http.post('/auth/login', {
          email: this.email.trim(),
          password: this.password
        })
        .then(request => this.loginSuccessful(request))
        .catch(() => this.loginFailed())
      },
      loginSuccessful (req) {
        if (!req.data.token) {
          this.loginFailed()
          return
        }
        localStorage.token = req.data.token
        this.$store.dispatch('login')
        this.error = false
        this.$router.replace(this.$route.query.redirect || '/home')
      },
      loginFailed () {
        this.error = 'Login failed!'
        this.openDialog = true
        this.$store.dispatch('logout')
        delete localStorage.token
      },
      signup () {
        this.$router.push('/signup')
      },
      reset () {
        this.$router.push('/resetpassword')
      }
    },
    props: {
      source: String
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login/Login.vue